import styled from "styled-components";
import { renderValueProp } from "./ValueProps.New";

const BrandValuePropsContainer = styled.div`
  @media (min-width: 768px) {
    display: flex;
    flex-direction: row;

    & > div {
      flex: 0 0 calc((100% - (var(--spacing-1_5) * 3)) / 4);
      margin-right: var(--spacing-1_5);

      &:last-child {
        margin-right: 0;
      }
    }
  }
`;

type BrandValuePropsProps = {
  valueProps: {
    name: string;
    icon: { file: { url: string } };
    disclaimer: string;
  }[];
};

const BrandValueProps = ({ valueProps }: BrandValuePropsProps) => {
  return (
    <BrandValuePropsContainer>
      {valueProps.map((valueProp) => {
        return renderValueProp(valueProp, 0, 0);
      })}
    </BrandValuePropsContainer>
  );
};

export default BrandValueProps;
